import type {
  DrupalBlock,
  DrupalImage as DrupalImageType,
  DrupalLink,
} from '@commons/types/drupal';
import type { Alignment, Theme } from '@commons/types/styles';

import TileBlockDefault from './Default';
import TileBlockFeatured from './Featured';

// Type definition of the Clickable Tile block variant.

enum TILE_VARIANT {
  Default = 'default',
  Featured = 'featured',
}

// Type definition for the Clickable Tile Block component properties.

export type TileBlockProps = DrupalBlock<{
  tag?: string;
  title: string;
  description?: string;
  theme: Theme;
  disableScroll?: boolean;
  link: DrupalLink;
  justify: Alignment;
  aspectRatio?: 'square' | 'portrait';
  image: DrupalImageType;
  variant?: TILE_VARIANT;
}>;

/**
 * Clickable Tile block component.
 *
 * Renders a component based on the variant.
 */

const ClickableTileBlock = (props: TileBlockProps) => {
  const { variant = 'default' } = props.content;

  switch (variant) {
    default:
    case TILE_VARIANT.Default:
      return <TileBlockDefault {...props} />;
    case TILE_VARIANT.Featured:
      return <TileBlockFeatured {...props} />;
  }
};

export default ClickableTileBlock;
